{
  "verification": {
    "age": {
      "title": "Verify your age",
      "body": "To keep Opncue for adults 18 and over, we may need to confirm your age.",
      "accountBody": "To keep Opncue for adults 18 and over, we need to confirm your age before you continue.",
      "featureBody": "To keep Opncue for adults 18 and over, we need to confirm your age before you use this feature.",
      "supportText": "This check is handled by our verification provider. Your age documents are not shown to other users.",
      "verifyButton": "Verify age",
      "pending": "Age check in progress",
      "success": "Age confirmed. You can continue using Opncue.",
      "failure": "We couldn’t confirm that you’re 18 or over."
    }
  }
}
